export default (
    url,
    jwtToken,
    method = 'GET',
    body = undefined,
    useBrowserDefault = false,
    accept = 1
) => {
    let headers;

    if (jwtToken) {
        headers = new Headers({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + jwtToken
        });
    } else {
        headers = new Headers({
            'Content-Type': 'application/json'
        });
    }

    if (useBrowserDefault) {
        headers.delete('Content-Type');
    }

    if (accept === 2) {
        headers.append('Accept', 2);
    }

    const settings = {
        cache: 'reload',
        method,
        headers,
        body
    };

    return fetch(url, settings).then(response => {
        // console.log(response);
        return response.json();
    });
};



// WEBPACK FOOTER //
// ./src/helpers/apiRequest.js